import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const AttendanceStaffSlice = createSlice({
  name: 'AttendanceStaff',
  initialState,
  reducers: {
    AttendanceStaff_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    AttendanceStaff_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    AttendanceStaff_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_AttendanceStaff_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {AttendanceStaff_request, AttendanceStaff_failure, AttendanceStaff_success, Clear_AttendanceStaff_Check } = AttendanceStaffSlice.actions

export default AttendanceStaffSlice.reducer